import { createAction, props } from '@ngrx/store';
import { IProducts } from '../models/products.model';

export const loadPastProductsForSomeoneElse = createAction(
  '[PastProductsForSomeoneElse] Load PastProductsForSomeoneElse',
  props<{ request: string }>()
);

export const loadPastProductsForSomeoneElseSuccess = createAction(
  '[PastProductsForSomeoneElse] Load PastProductsForSomeoneElse Success',
  props<{ response: IProducts[] }>()
);

export const loadPastProductsForSomeoneElseFailure = createAction(
  '[PastProductsForSomeoneElse] Load PastProductsForSomeoneElse Failure',
  props<{ error: Error | any }>()
);
